import { Divider, Input } from "@chakra-ui/react";
import {
  FormFieldLabel,
  FormFieldLabelProps,
} from "../formFieldLabel/FormFieldLabel";
import { FormSubSectionHeader } from "../formSubSectionHeader/FormSubSectionHeader";

export interface FormInputFieldProps extends FormFieldLabelProps {
  placeholder?: string;
  /**
   * Is this field required?
   */
  fieldType: "text" | "email" | "password";
  /**
   * Is the form valid (usually after submission checks)
   */
  inputFieldProps?: Record<string, any>;
  disabled?: boolean;
  title?: string;
  isAdmin?: boolean;
}

export const FormInputField = ({
  placeholder,
  fieldType,
  label,
  inputFieldProps,
  disabled = false,
  title,
  isAdmin = false,
  ...fieldLabelProps
}: FormInputFieldProps) => {
  placeholder = placeholder ? placeholder : label;
  return (
    <>
      {title && (
        <>
          <FormSubSectionHeader label={title} />
          <Divider mt={0} mb={4} />
        </>
      )}
      <FormFieldLabel {...fieldLabelProps} label={label} isAdmin={isAdmin}>
        <Input
          {...inputFieldProps}
          data-testid={"input-field"}
          type={fieldType}
          placeholder={placeholder}
          isDisabled={disabled}
        />
      </FormFieldLabel>
    </>
  );
};
